import { css, keyframes } from '@emotion/react';
import { Box, Flex, FlexProps } from '@opendoor/bricks/core';
import NextImage from 'next/image';

import { imgixLoader } from '../../../helpers/imgixUrl';

function createFadeAnimation(opacityValue: 0 | 1) {
  return keyframes`
  0% {
    opacity: 1;
    transform: scale(0.9);
  }

  30% {
    transform: scale(0.95);
  }

  50% {
    transform: scale(1);
  }

  100% {
    opacity: ${opacityValue};
    transform: scale(1);
  }
`;
}

export const MarkerPulse = css({
  opacity: 0,
  transform: 'scale(1)',
  animation: `${createFadeAnimation(0)} 5s infinite`,
});

export const MarkerFadeIn = css({
  opacity: 0,
  transform: 'scale(1)',
  animation: `${createFadeAnimation(1)} 5s forwards`,
});

const Marker = ({
  imageSource,
  animationDelay = '0s',
  ...props
}: { imageSource: string; animationDelay?: string } & FlexProps) => {
  return (
    <Box
      position="absolute"
      {...props}
      style={{
        animationDelay,
      }}
    >
      <Flex justifyContent="center" alignItems="center" width="100%">
        <NextImage
          layout="fill"
          loader={imgixLoader}
          src={imageSource}
          alt="Map marker for a home"
          priority={true}
        />
      </Flex>
    </Box>
  );
};

export default Marker;
